// export const url = "https://xtratoys.nextechltd.in/api";
//export const url = "https://demopos.nextechltd.in/api";

// export const url = "http://103.241.144.228:8000/api";
 export const url = "https://admindev.nextechltd.in/api";
 
export const isAdmin = true;

export const adminUrl = "https://admindev.nextechltd.in/api";
